export default {
  'buttons.learnMore': '了解更多',
  'buttons.getStarted': '立即开始',
  'buttons.contact': '联系我们',
  'buttons.demo': '获取演示',
  'buttons.consult': '立即咨询',
  'buttons.getDemoSolution': '获取演示方案',
  'navigation.home': '首页',
  'navigation.products': '产品矩阵',
  'navigation.products.worktool': 'WorkTool数字助手',
  'navigation.products.chatlink': 'ChatLink知识问答',
  'navigation.products.outbound': '智能外呼机器人',
  'navigation.products.huitianAi': '回甜AI',
  'navigation.products.mcp': 'MCP Filesystem',
  'navigation.products.aiGateway': 'AI网关',
  'navigation.cases': '客户案例',
  'navigation.private': '私有化部署',
  'navigation.about': '关于我们',
  'navigation.pricing': '定价',
  'navigation.status': '服务状态',
  'navigation.contact': '联系我们',
  loading: '加载中...',
  error: '错误',
  success: '成功',
  confirm: '确认',
  cancel: '取消',
};
